import { Button, Spinner } from '@livingdesign/react';
import React, { useState } from 'react'
import { useCampaignContext } from '../../../../../contexts/Campaign';
import { useMessageDetailsForm } from '../../../../../contexts/MessageDetailsForm';
import _ from 'lodash';
import { CAMPAIGN_EDIT_STEP_VALIDATION_STATE } from '../../../../../consts/CampaignEdit';

export const QA_ID_PREFIX = "EditLayout-EditFormActionsFooter";

function EditFormActionsFooter({
    loading,
    continueLabel = "Continue",
    saveDraftLabel = "Save as draft",
    previousLabel = "Previous",
    onPrevious,
    onSaveDraft,
    onContinue,
    disableContinue,
    hideContinueButton,
    hidePreviousButton,
    stepIndex,
}) {

    return (
        <div className='campaign-edit-action-button' data-testid={`${QA_ID_PREFIX}-container`}>
            <div data-testid={`${QA_ID_PREFIX}-previous-container`}>
            {!hidePreviousButton && 
                <Button
                    UNSAFE_style={{visibility: (stepIndex === 0) ? 'hidden' : 'visible'}}
                    variant='secondary'
                    disabled={loading}
                    onClick={onPrevious}
                    data-testid={`${QA_ID_PREFIX}-previous-button`}
                >
                    {previousLabel}
                </Button>
            }
            </div>
            <div style={{display: "flex"}} data-testid={`${QA_ID_PREFIX}-actions-container`}>
                <Button
                    UNSAFE_className='save-draft-btn'
                    onClick={onSaveDraft}
                    disabled={loading}
                    data-testid={`${QA_ID_PREFIX}-save-draft-button`}
                >
                    {saveDraftLabel}
                </Button>
                {(!hideContinueButton) && 
                    <Button
                        variant='primary'
                        onClick={onContinue}
                        disabled={loading || disableContinue}
                        UNSAFE_className='continue-btn'
                        data-testid={`${QA_ID_PREFIX}-continue-button`}
                    >
                        {loading 
                            ?
                            <Spinner size='small' data-testid={`${QA_ID_PREFIX}-spinner`}/>
                            :
                            continueLabel
                        }
                    </Button>
                }
            </div>
        </div>
    )
}

export default EditFormActionsFooter;